import { createSlice } from "@reduxjs/toolkit";

const aiChatSlice = createSlice({
    name: "aiChat",
    initialState: {
        threads : ""
    },
    reducers:{
        setThreads : (state, action) => {
            state.threads = action.payload;
        },
        updateThread : (state, action) => {
            const { thread_id, updatedThread } = action.payload;
            const threadIndex = state.threads.findIndex(thread => thread?.thread_id === thread_id);

            const getLatestConversationTimestamp = (thread) => {
                if (thread?.conversations && thread.conversations.length > 0) {
                    const latestConversation = [...thread.conversations].sort((a, b) => 
                        new Date(b.createdAt) - new Date(a.createdAt)
                    )[0];

                    return latestConversation.createdAt;
                }

                return thread.updated_at || new Date().toISOString(); 
            };

            if (threadIndex !== -1) {
                const mergedThread = { 
                    ...state.threads[threadIndex], 
                    ...updatedThread 
                };

                const latestTimestamp = getLatestConversationTimestamp(mergedThread);

                state.threads[threadIndex] = { 
                    ...mergedThread,
                    updated_at: latestTimestamp // Use the calculated latest timestamp
                };
            } else {
                const latestTimestamp = getLatestConversationTimestamp(updatedThread);
        
                state.threads.push({
                    ...updatedThread,
                    updated_at: latestTimestamp
                });
            }
        },
    }
})

export const {
    setThreads,
    updateThread,
} = aiChatSlice.actions;

export default aiChatSlice.reducer;